import React, { useState, useRef, useEffect } from "react"
import { request } from "../utils/apiHelper.js"
import { ToastStore } from "../app/toastStore.js"
import { useStore } from "@nanostores/react"
import { currentLocationStore } from "../app/userLocationStore"
import { ModalStore } from "../app/modalStore.js"
import PhoneInput from "react-phone-input-2"
import "react-phone-input-2/lib/bootstrap.css"
import Anchor from "./Anchor.jsx"
import { IoClose } from "react-icons/io5"

function WaitlistModal() {
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [countryCode, setCountryCode] = useState("")
  const [ticketAmount, setTicketAmount] = useState(1)
  const [firstName, setFirstName] = useState("")
  const userLocation = currentLocationStore.get()
  const modalStore = useStore(ModalStore)
  const modalRef = useRef(null)

  const event = modalStore?.waitListEvent
  const setIsOpen = () => ModalStore.set({ ...modalStore, waitListEvent: null })

  useEffect(() => {
    if (!event) return

    function handleClickOutside(e) {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setIsOpen()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [event])

  const handleSubmit = async (e) => {
    e.preventDefault()
    const res = await request("POST", "/api/v1/iterable/tickets_waitlist", {
      firstName,
      email,
      event,
      ticketAmount,
      phone: `+${phone}`,
      location_slug: userLocation?.slug || "new-york-city",
    })
    setIsOpen(false)
    if (res.status === "success") {
      ToastStore.set({ status: "success", message: res.message })
    } else {
      ToastStore.set({ status: "error", message: res.message })
    }
  }

  const handlePhoneChange = (e) => {
    const { name, value, type, newCountryCode } = e.target

    if (type === "phone") {
      let phoneNumber = value
      const currentCountryCode = `+${countryCode}`

      if (!phoneNumber.startsWith(`+${newCountryCode}`)) {
        setCountryCode(newCountryCode)
        phoneNumber = `${phoneNumber.replace(currentCountryCode, "").trim()}`
      }
      setPhone(phoneNumber)
    }
  }

  if (!event) return

  return (
    <div
      className="fixed z-[1000] inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div 
          ref={modalRef}
          className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[590px] sm:w-full relative"
        >
          <button
            type="button"
            onClick={() => setIsOpen()}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 transition-colors focus:outline-none"
            aria-label="Close modal"
          >
            <IoClose size={24} />
          </button>
          
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <h3
              className="text-3xl variant-h3 text-gray-900 text-center"
              id="modal-title"
            >
              Tickets not available now
            </h3>
            <div className="mt-2 flex flex-col items-center mt-6 variant-body-1">
              <div className="text-center">
                <p>Join our waitlist</p>
                <p>We&apos;ll let you know when tickets are available</p>
              </div>
              <form
                id={"waitlist-modal-form"}
                onSubmit={handleSubmit}
                className="flex flex-col max-w-[495px] w-full mt-10"
              >
                <label>First Name</label>
                <input
                  placeholder="Type here..."
                  className="rounded-[5px] border border-[#ACACAC] p-3"
                  value={firstName}
                  required
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <label className="mt-5">Email</label>
                <input
                  type="email"
                  placeholder="Type here..."
                  className="rounded-[5px] border border-[#ACACAC] p-3"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                />

                <label className="mt-5">Phone Number</label>

                {/* PhoneInput component */}
                <PhoneInput
                  preferredCountries={["us", "ca", "gb"]}
                  type="phone"
                  name="phoneNumber"
                  specialLabel=""
                  onChange={(value, inputData) => {
                    handlePhoneChange({
                      target: {
                        name: "phoneNumber",
                        value: value,
                        type: "phone",
                        newCountryCode: inputData.dialCode,
                      },
                    })
                  }}
                  value={phone}
                  country={"us"}
                  inputStyle={{
                    width: "100%",
                  }}
                  // countryOptionsOrder={['US', 'CA']}
                  inputProps={{
                    id: "phone-field",
                    className: `
                                  max-w-full 
                                  h-11 
                                  w-full 
                                  md:min-w-[495px] 
                                  sm:max-w-sm 
                                  px-13
                                  border 
                                  border-gray-80 
                                  rounded-[5px] 
                                  z-0 
                                  focus:shadow 
                                  focus:outline-none
                                `,
                  }}
                  enableSearch={true}
                  countryCodeEditable={false}
                  autoFormat={false}
                />

                <label className="mt-5">How many tickets would you like?</label>
                <input
                  className="rounded-[5px] border border-[#ACACAC] p-3"
                  value={ticketAmount}
                  required
                  type={"number"}
                  min="1"
                  max="4"
                  onChange={(e) => setTicketAmount(Number(e.target.value))}
                />
                <Anchor
                  href={`/${
                    userLocation?.slug || "new-york-city"
                  }/terms-and-conditions`}
                  onClick={() => setIsOpen(false)}
                >
                  <p className="mt-3 text-center text-[#646464] text-[14px]">
                    By signing up for the waitlist I agree to receive City
                    Winery email and text marketing (21+ only) and I accept City
                    Winery's Terms of Use and Privacy Policy. Msg & data rates
                    may apply. Reply STOP to cancel anytime
                  </p>
                </Anchor>
              </form>
            </div>
          </div>
          <div className="border-t border-[#DFDFDF] p-8 flex justify-between mt-16 gap-4">
            <button
              type="button"
              className="w-full capitalize inline-flex justify-center rounded-md border border-black shadow-sm px-3 py-4 bg-white text-[18px] variant-h3 text-black max-w-[165px]"
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              form={"waitlist-modal-form"}
              className="w-full capitalize inline-flex justify-center rounded-md border border-white shadow-sm px-3 py-4 bg-black text-[18px] variant-h3 text-white max-w-[165px]"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WaitlistModal
